/* Replicates frontend/web ZoomWrapper: the site is authored on a 1920px canvas and
   scaled down on desktop. Above 1024px: zoom = max(viewport / 1920, 0.72); below: no zoom. */
(function () {
  var BASE_WIDTH = 1920;
  var DESKTOP_BREAKPOINT = 1024;
  var MIN_ZOOM = 0.72;

  function apply() {
    var zoom =
      window.innerWidth > DESKTOP_BREAKPOINT
        ? String(Math.max(window.innerWidth / BASE_WIDTH, MIN_ZOOM))
        : '';

    var roots = document.querySelectorAll('[data-ls-zoom]');
    for (var i = 0; i < roots.length; i++) {
      roots[i].style.zoom = zoom;
    }
  }

  apply();
  window.addEventListener('resize', apply, { passive: true });
  document.addEventListener('shopify:section:load', apply);
})();
